import { useState } from 'react';
import { Link } from 'react-router-dom';
import { procurementApi } from '../../api/procurement';

export function MRPPlanningPage() {
  const [plans, setPlans] = useState<unknown[]>([]);
  const [msg, setMsg] = useState('');

  async function runMRP() {
    const result = await procurementApi.runMRP([
      { sku: 'SKU-001', on_hand: 50, demand_forecast: 200, safety_stock: 30, lead_time_days: 7 },
      { sku: 'SKU-002', on_hand: 20, demand_forecast: 150, safety_stock: 25, lead_time_days: 10 },
    ]);
    setPlans(result);
    setMsg(`Generated ${result.length} MRP plan(s)`);
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/procurement" className="text-sm text-slate-600 hover:underline">← Procurement hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">MRP & purchase planning</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void runMRP()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Run MRP</button>
      {plans.length > 0 && (
        <pre className="mt-4 overflow-auto rounded border p-3 text-xs">{JSON.stringify(plans, null, 2)}</pre>
      )}
    </div>
  );
}
